<div class="modal-header">
  <h2 class="modal-title">{{ "contracts.filterModal.title" | translate }}</h2>
  <button type="button"
    class="btn-close"
    aria-label="Close"
    (click)="filterModalActionClick()"
  >
  </button>
</div>

<div class="modal-body">
  <div class="filter-section date-section pb-4">
    <div class="filter-section-title mb-2">
      {{ "contracts.filterModal.activeDateTitle" | translate }}
    </div>
    <div class="col-md-6 select-date">
      <label class="label-input">
        {{ "contracts.filterModal.endDate" | translate }}
      </label>
      <kendo-datepicker HJSuppress
        class="custom-kendo-control-xl"
        [fillMode]="fillModeOutline"
        [rounded]="roundedLarge"
        [(ngModel)]="terminationUntilDate"
        #endDate
        (click)="!endDate.isOpen ? endDate.toggle() : null"
        [popupSettings]="{popupClass : 'data-hj-suppress'}"
      >
        <kendo-datepicker-messages
          today="{{ 'calendar.today' | translate }}"
          toggle="{{ 'calendar.toggle' | translate }}"
        >
        </kendo-datepicker-messages>
      </kendo-datepicker>
    </div>
  </div>

  <div class="filter-section categories-section pt-4 py-3">
    <div class="filter-section-title mb-2">
      {{ "contracts.filterModal.contractCategoriesTitle" | translate }}
    </div>
    <div class="row">
      <div
        *ngFor="let contractType of contractTypes"
        class="col-md-6 d-flex align-items-center mb-3"
      >
        <input
          type="checkbox"
          kendoCheckBox
          [size]="size"
          [id]="contractType.value"
          [rounded]="roundedLarge"
          [(ngModel)]="contractType.isSelected"
        />
        <label HJSuppress [for]="contractType.value" class="cursor-pointer ms-2">
          {{ contractType.name }}
        </label>
      </div>
    </div>
  </div>
  <div class="filter-section status-section pt-4 pb-3">
    <div class="filter-section-title mb-2">
      {{ "contracts.filterModal.invoiceStatusTitle" | translate }}
    </div>
    <div class="row">
      <div
        *ngFor="let status of statuses; index as i"
        class="col-md-6 d-flex align-items-center mb-3"
      >
        <input
          type="checkbox"
          kendoCheckBox
          [size]="size"
          [id]="status.name + i"
          [rounded]="roundedLarge"
          [(ngModel)]="status.isSelected"
        />
        <label HJSuppress [for]="status.name + i" class="cursor-pointer ms-2">
          {{ status.name }}
        </label>
      </div>
    </div>
  </div>
  <div class="assets-section pt-4">
    <div class="filter-section-title mb-2">
      {{ "contracts.filterModal.assetsTitle" | translate }}
    </div>
    <div class="row justify-content-center mb-3">
      <div class="col">
        <div class="custom-text-input-container search-container contract-search-container">
          <i class="app-icon icon icon-search icon-xl"></i>
          <div class="custom-text-input-wrap">
            <kendo-textbox
              type="text"
              [clearButton]='true'
              placeholder="{{'contracts.filterModal.assetFilterPlaceholder' | translate}}"
              [(ngModel)]="assetSearchText"
              (valueChange)="onSearchTextChange($event)"
            >
            </kendo-textbox>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        *ngFor="let asset of filteredAssets"
        class="col-md-6"
        (click)="selectAssetHandler(asset.assetId)"
      >
        <div
          class="asset-box p-3 cursor-pointer"
          [ngClass]="{ active: asset.isSelected }"
        >
          <div class="d-flex align-items-center mb-2">
            <input
              type="checkbox"
              kendoCheckBox
              [size]="size"
              [id]="asset.assetId"
              [rounded]="roundedLarge"
              [(ngModel)]="asset.isSelected"
            />
            <span HJSuppress class="ms-2 fw-semibold">{{ asset.name }}</span>
          </div>

          <div class="contract-row">
            {{ "contracts.filterModal.VIN" | translate }}:
            <span HJSuppress class="fw-semibold">{{ asset.uid }}</span>
          </div>
          <div class="contract-row">
            {{ "contracts.filterModal.plateNumber" | translate }}:
            <span HJSuppress class="fw-semibold">{{ asset.number }}</span>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center my-4 py-3" *ngIf="assetSearchText && filteredAssets.length === 0" >
        <button class="btn outline-btn" (click)="switchContractActiveStateHandler()">
            <ng-container *ngIf="contractsFilter.activeContracts">
              {{'asset.contractPopup.loadAssetsFromInactiveConctracts' | translate}}
            </ng-container>

            <ng-container *ngIf="!contractsFilter.activeContracts">
              {{'asset.contractPopup.loadAssetsFromActiveConctracts' | translate}}
            </ng-container>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn link-btn" (click)="resetFilterHandler()">
    <i class="app-icon icon icon-reload icon-lg me-2"></i>
    {{ "contracts.filterModal.reset" | translate }}
  </button>
  <button class="btn primary-btn" (click)="filterModalActionClick(true)">
    {{ "contracts.filterModal.apply" | translate }}
  </button>
</div>
